import { ATTRIBUTES_KEYS_BY_TYPE } from '../constants';

export function isAttributesValid(attributes) {
  let valid = true

  if (typeof attributes === 'object') {
    const keys = Object.keys(attributes)
    if (keys.length > 5) {
      return false
    }

    keys.forEach(key => {
      if (!key || key[0] === ' ' || key[key.length - 1] === ' ' || key[0] === '_' || key.length > 32) {
        valid = false
      }
    })

    Object.values(attributes).forEach(value => {
      if (typeof value !== 'string') {
        valid = false
      }
    })
  }

  return valid
}

export function isMetricsValid(metrics, predicate) {
  let valid = true

  if (typeof metrics === 'object') {
    const keys = Object.keys(metrics)
    for (let i = 0; i < keys.length; i++) {
      const value = metrics[keys[i]]
      let predicateResult = true
      if (predicate && typeof predicate === 'function') {
        predicateResult = predicate(value)
      }

      if (typeof value === 'undefined' || typeof value !== 'number' || !predicateResult) {
        valid = false
        break
      }
    }
  }

  return valid
}

export function filterAttributes(endpoint, type, attributes) {
  const config = ATTRIBUTES_KEYS_BY_TYPE[endpoint] || {};
  const keys = config[type] || [];

  const result = {};
  Object.keys(attributes).forEach(key => {
    if (keys.indexOf(key) > -1) {
      result[key] = attributes[key];
    }
  });

  return result;
}